var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 444.2816,
    height: 444.2816,
    viewBox: "0 0 444.2816 444.2816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdbdbd;}.cls-2{fill:#ababab;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 222.1408,
    cy: 222.1408,
    r: 222.1307
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.8841,159.738c-.1219,8.642-1.4534,17.2307-1.8108,25.8613a12.8218,12.8218,0,0,0,1.67,6.2845,18.6205,18.6205,0,0,0,2.7744,3.69c5.332,5.3055,9.8859,4.9171,15.05,2.8505a239.9242,239.9242,0,0,0,24.2851-11.3617c10.1083-5.4268,19.704-11.7357,31.7144-12.4538,22.5129-1.346,45.3273,17.1393,50.7915,38.6339,7.53,29.6195-20.3848,74.7105-62.5319,75.0205-23.3447.1716-43.5607-7.8317-61.9209-21.2734-2.2689-1.6611-4.6344-3.9-6.7022-5.5287-4.5937-3.6173-10.2109-2.3177-13.9664-.4556a13.0426,13.0426,0,0,0-5.1454,5.4965c-3.9231,8.339-4.42,17.292-4.701,26.32-.3149,10.1216.4426,20.5331-1.679,30.2941-6.4867,29.8432-43.3247,45.3876-70.349,31.156-26.1765-13.785-47.0331-58.923-21.2526-95.0772,13.0244-18.2652,30.56-30.33,50.9072-38.7871,3.7731-1.5683,5.9066-3.7777,7.6386-7.7523a16.9312,16.9312,0,0,0,1.0526-3.751c.991-6.8342-1.1534-9.8112-6.1494-13.9142a188.7959,188.7959,0,0,0-16.9849-12.187c-6.1341-3.9889-12.8648-7.1047-18.7945-11.3556-27.0235-19.3723-25.1023-62.4525,2.8295-80.53,25.0986-16.2442,75.1964-11.807,93.2736,28.7742C245.3036,134.1056,249.067,146.7774,248.8841,159.738Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFan);
export default __webpack_public_path__ + "static/media/icons-fan.77a1f0d079d4296df4c303eb8ef35cb7.svg";
export { ForwardRef as ReactComponent };